/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './InvestView.scss';
import AddDistrictDetails from '../../Panels/AddDistrictDetails/AddDistrictDetails';
import ListViews from '../../Panels/ListViews/ListViews';
import BasePanel from '../../Panels/BasePanel';

class InvestView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inwestycje: null,
      selected: null,
      selected_edit: null,
      lang: null,
      idoferty: null,
      result: null
    }
  }
  componentDidMount() {
    fetch(`${process.env.OLD_IHUB}/invest?gmina=${this.props.district.prefix}`)
    .then(r => r.json())
    .then(resp => {
      this.setState({
        inwestycje: resp
      })
    })
  }

  selectInvest = (v, lang) => {
    fetch(`${process.env.API_URL}/einvest/${this.props.district.prefix}/info?id=${v.properties.id}`)
    .then(r => r.json())
    .then(resp => {
      this.setState({
        selected: {...v.properties, resp},
        selected_edit: {...v.properties, resp},
        lang: lang,
        idofery: v.properties.id,
        result: null
      })
    })
  }
  
  onChangeSelect = (e, name) => {
    this.setState({
      selected: {
        ...this.state.selected,
        [name]: e.target.value
      }
    })
  }

  onChange = (e, keys, v, j, i) => {
    const changed = this.state.selected.resp[this.state.lang].map((v, item_index) => {
      if (item_index === i) {
        v[keys].map((subitem, subitem_index) => {
          if (subitem_index === j) {
            subitem['tekst'] = e.target.value;
          }
          return subitem;
        })
      }
      return v;
    })

    this.setState({
      selected: {
        ...this.state.selected,
        resp: {
          ...this.state.selected.resp,
          [this.state.lang]: [...changed]
        }
      }
    })
  }

  update = () => {
    fetch(`${process.env.API_URL}/invest?gmina=${this.props.district.prefix}&id=${this.state.idoferty}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        "nazwa": this.state.selected.nazwa,
        "nazwa_en": this.state.selected.nazwa_en,
        "nazwa_de": this.state.selected.nazwa_de,
      }),
    })
      .then(r => r.json());

    fetch(`${process.env.API_URL}/einvest/${this.props.district.prefix}/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(this.state.selected.resp[this.state.lang]),
    })
    .then(r => r.json())
    .then(resp => {
      this.setState({
        result: resp
      })
    })
    .catch(resp => {
      this.setState({
        result: resp
      })
    })
  }

  render() {
    return (
      <div>
       	<div className="col-sm-6">
          <BasePanel fullWidth user={this.props.user}  style={{textAlign: "center"}} panelType="primary" panelTitle="Lista ofert inwestycyjnych">
            <table className="table">
            <thead>
              <tr>
                <th scope="col">Nazwa</th>
                <th scope="col">Język polski</th>
                <th scope="col">Język angielski</th>
                <th scope="col">Język niemiecki</th>
              </tr>
            </thead>
            <tbody>
              {this.state.inwestycje ? this.state.inwestycje.features.map((v, i) => {
                return (
                  <tr key={i}>
                    <td>{v.properties.nazwa}</td>
                    <td className="edit" onClick={() => this.selectInvest(v, 'pl')}>Edytuj</td>
                    <td className="edit" onClick={() => this.selectInvest(v, 'en')}>Edytuj</td>
                    <td className="edit" onClick={() => this.selectInvest(v, 'de')}>Edytuj</td>
                  </tr>
                )
              }) : null}
            </tbody>
            </table>
          </BasePanel>
        </div>

        <div className="col-md-6">
          <BasePanel fullWidth user={this.props.user}  style={{textAlign: "center"}} panelType="primary" panelTitle="Edycja oferty inwestycyjnej">
            {this.state.result ? this.state.result : null}
            {this.state.selected ? 
            <div>
              <button className="btn btn-primary pull-right" onClick={() => this.update()}>Zapisz</button>
              <h4>Język {this.state.lang == 'pl' ? <span>polski</span> : (this.state.lang == 'en' ? <span>angielski</span> : <span>niemiecki</span>)}</h4>
              <div class="form-group">
                <label>Nazwa</label>
                {this.state.lang == 'pl' ? <input type="text" onChange={(e) => this.onChangeSelect(e, 'nazwa')} className="form-control" value={this.state.selected.nazwa} /> : null}
                {this.state.lang == 'en' ? <input type="text" onChange={(e) => this.onChangeSelect(e, 'nazwa_en')} className="form-control" value={this.state.selected.nazwa_en} /> : null}
                {this.state.lang == 'de' ? <input type="text" onChange={(e) => this.onChangeSelect(e, 'nazwa_de')} className="form-control" value={this.state.selected.nazwa_de} /> : null}
              </div>
              {this.state.selected.resp[this.state.lang].map((v, i) => {
                return <div key={i}>
                  <h4>{Object.keys(v)}</h4>
                    {Object.values(v)[0].map((b, j) => {
                      return <div className="form-group" key={j}>
                        <label>{b.subkategoria}</label>
                        <input className="form-control" value={b.tekst} name={b.subkategoria} onChange={(e) => this.onChange(e, Object.keys(v)[0], v, j, i)}/>
                      </div>
                    })}
                </div>
              })}
              <button className="btn btn-primary pull-right" onClick={() => this.update()}>Zapisz</button>
            </div> : <p>Nie wybrano oferty inwestycyjnej do edycji!</p>}
          </BasePanel>
        </div>
      </div>
    );
  }
}

InvestView.PropTypes = {
  viewName: PropTypes.string.isRequired,
  viewDesc: PropTypes.string.isRequired,
};

export default withStyles(s)(InvestView);



// WEBPACK FOOTER //
// src/components/Modals/Settings/SettingsViews/InvestView/InvestView.js